module.exports = {
    pca: require('./pca'),
    pcaa: require('./pcaa')
};